import styled from "styled-components";

export const DoctorViewOuter = styled.div``;
